<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>

<template>
  <div class="border-error border-1 py-sm px-md rounded-button text-error text-center">
    {{ label }}
  </div>
</template>
